/**
 * Format status strings for display
 * Converts database status values to human-readable format
 */

/**
 * Format submission status for display
 * @param {string} status - Raw status from database (in_progress, completed, expired)
 * @returns {string} Formatted status
 */
export const formatSubmissionStatus = (status) => {
  if (!status) return 'Unknown';

  const statusMap = {
    'in_progress': 'In Progress',
    'completed': 'Completed',
    'expired': 'Expired',
    'submitted': 'Submitted', // Legacy support
  };

  return statusMap[status] || capitalizeFirst(status.replace(/_/g, ' '));
};

/**
 * Format quiz status for display
 * @param {string} status - Raw status from database (draft, published, closed, archived)
 * @returns {string} Formatted status
 */
export const formatQuizStatus = (status) => {
  if (!status) return 'Unknown';

  const statusMap = {
    'draft': 'Draft',
    'published': 'Published',
    'closed': 'Closed',
    'archived': 'Archived',
  };

  return statusMap[status] || capitalizeFirst(status.replace(/_/g, ' '));
};

/**
 * Helper function to capitalize first letter of each word
 * @param {string} str - Input string
 * @returns {string} Capitalized string
 */
const capitalizeFirst = (str) => {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Get color classes for submission status badge
 * @param {string} status - Raw status from database
 * @returns {string} Tailwind CSS classes
 */
export const getSubmissionStatusColor = (status) => {
  const colorMap = {
    'completed': 'bg-emerald-50 text-emerald-700 border-emerald-200',
    'in_progress': 'bg-amber-50 text-amber-700 border-amber-200',
    'expired': 'bg-red-50 text-red-600 border-red-200',
    'submitted': 'bg-emerald-50 text-emerald-700 border-emerald-200', // Legacy
  };

  return colorMap[status] || 'bg-slate-100 text-slate-600 border-slate-200';
};

/**
 * Get color classes for quiz status badge
 * @param {string} status - Raw status from database
 * @returns {string} Tailwind CSS classes
 */
export const getQuizStatusColor = (status) => {
  const colorMap = {
    'published': 'bg-emerald-50 text-emerald-700 border-emerald-200',
    'closed': 'bg-slate-100 text-slate-600 border-slate-200',
    'draft': 'bg-amber-50 text-amber-700 border-amber-200',
    'archived': 'bg-red-50 text-red-700 border-red-200',
  };

  return colorMap[status] || 'bg-slate-100 text-slate-600 border-slate-200';
};
